import { isMps } from 'partner360/components/partnerRanks/components/rankIcon/helpers/isMps'
import { isStrategicPrintServices } from 'partner360/components/partnerRanks/components/rankIcon/helpers/isStrategicPrintServices'
import { isStrategicPsServices } from 'partner360/components/partnerRanks/components/rankIcon/helpers/isStrategicPsServices'
import { IP360PartnerFlags } from 'partner360/models/p360PartnerFlags/IP360PartnerFlags'

import { OTHER_FLAG } from '../configs'

import { isPoly } from './isPoly'
import { isTopDistributor } from './isTopDistributor'
import { isTopMarket } from './isTopMarket'
import { isTopWW } from './isTopWW'

export const canRenderRankIcon = (rank?: IP360PartnerFlags | null, isOnlyTop?: boolean) => {
  if (!rank) {
    return false
  }

  if (isOnlyTop) {
    return (
      [isTopMarket, isTopWW, isTopDistributor].some((fn) => fn(rank.Icon)) ||
      [isPoly].some((fn) => fn(rank.PartnerFlag)) ||
      rank.PartnerFlag === OTHER_FLAG
    )
  }

  return (
    [isTopMarket, isTopWW, isTopDistributor].some((fn) => fn(rank.Icon)) ||
    [isPoly, isMps, isStrategicPrintServices, isStrategicPsServices].some((fn) =>
      fn(rank.PartnerFlag)
    ) ||
    rank.PartnerFlag === OTHER_FLAG
  )
}
